import React from 'react';
import { 
  Sliders, 
  Clock, 
  Target, 
  MousePointer, 
  Users, 
  Image, 
  Video, 
  Mail 
} from 'lucide-react';

/**
 * Компонент боковой панели для быстрой настройки рекламной кампании
 */
const QuickAdjustmentSidebar = ({ 
  formData, 
  setFormData, 
  errors, 
  isCalculating 
}) => {
  // Пресеты для быстрой настройки кампании
  const quickPresets = [
    {
      name: 'Поисковая реклама',
      description: 'Фокус на точечном поиске клиентов',
      action: () => {
        setFormData(prev => ({
          ...prev,
          platforms: {
            ...prev.platforms,
            search: { ...prev.platforms.search, enabled: true },
            social: { ...prev.platforms.social, enabled: false },
            display: { ...prev.platforms.display, enabled: false },
            video: { ...prev.platforms.video, enabled: false },
            email: { ...prev.platforms.email, enabled: false }
          },
          goals: {
            awarenessWeight: '20',
            engagementWeight: '30',
            conversionWeight: '50'
          }
        }));
      },
      icon: MousePointer
    },
    {
      name: 'Социальные сети',
      description: 'Максимальный охват и узнаваемость',
      action: () => {
        setFormData(prev => ({
          ...prev,
          platforms: {
            ...prev.platforms,
            search: { ...prev.platforms.search, enabled: false },
            social: { ...prev.platforms.social, enabled: true },
            display: { ...prev.platforms.display, enabled: true },
            video: { ...prev.platforms.video, enabled: true },
            email: { ...prev.platforms.email, enabled: false }
          },
          goals: {
            awarenessWeight: '50',
            engagementWeight: '40',
            conversionWeight: '10'
          }
        }));
      },
      icon: Users
    },
    {
      name: 'Комплексная кампания',
      description: 'Использование всех каналов',
      action: () => {
        setFormData(prev => ({
          ...prev,
          platforms: {
            ...prev.platforms,
            search: { ...prev.platforms.search, enabled: true },
            social: { ...prev.platforms.social, enabled: true },
            display: { ...prev.platforms.display, enabled: true },
            video: { ...prev.platforms.video, enabled: true },
            email: { ...prev.platforms.email, enabled: true }
          },
          goals: {
            awarenessWeight: '30',
            engagementWeight: '30',
            conversionWeight: '40'
          }
        }));
      },
      icon: Sliders
    }
  ];

  // Пресеты для длительности кампании
  const durationPresets = [
    { 
      name: '2 недели', 
      value: '14', 
      icon: Clock 
    },
    { 
      name: '1 месяц', 
      value: '30', 
      icon: Clock 
    },
    { 
      name: '3 месяца', 
      value: '90', 
      icon: Clock 
    }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Sliders className="w-5 h-5 mr-2 text-indigo-500" />
        Быстрая настройка
      </h3>

      {/* Пресеты рекламных кампаний */}
      <div className="mb-6">
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
          Шаблоны кампаний
        </h4>
        <div className="space-y-3">
          {quickPresets.map((preset, index) => (
            <button
              key={index}
              onClick={preset.action}
              disabled={isCalculating}
              className="w-full flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-700/30 rounded-lg border border-gray-200 dark:border-gray-700 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors disabled:opacity-50"
            >
              <div className="flex items-center">
                <preset.icon className="w-5 h-5 mr-3 text-indigo-500" />
                <div className="text-left">
                  <p className="text-sm font-medium text-gray-900 dark:text-white">{preset.name}</p>
                  <p className="text-xs text-gray-500 dark:text-gray-400">{preset.description}</p>
                </div>
              </div>
            </button>
          ))}
        </div>
      </div>

      {/* Пресеты длительности */}
      <div>
        <h4 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">
          Длительность кампании
        </h4>
        <div className="grid grid-cols-3 gap-2">
          {durationPresets.map((preset, index) => (
            <button
              key={index}
              onClick={() => {
                if (!isCalculating) {
                  setFormData(prev => ({
                    ...prev,
                    campaignDuration: preset.value
                  }));
                }
              }}
              disabled={isCalculating}
              className={`py-2 px-3 rounded-lg text-sm font-medium transition-colors flex items-center justify-center ${
                formData.campaignDuration === preset.value
                  ? 'bg-indigo-500 text-white'
                  : 'bg-gray-50 dark:bg-gray-700/30 text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-700 border border-gray-200 dark:border-gray-700'
              } disabled:opacity-50`}
            >
              <preset.icon className="w-4 h-4 mr-1" />
              {preset.name}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default QuickAdjustmentSidebar;